<template>
    <div class="infor fl box_bg">
        <div class="notice-tab">
            <div :class="statusTab==0?'focus':''" @click.stop="setTab(0)">协会通知<span></span></div>
            <div :class="statusTab==1?'focus':''" @click.stop="setTab(1)">年会通知<span></span></div>
            <!-- <span class="du" v-if="infoFlag&&statusTab==0"><img src="../assets/nsee.png" />一键已读</span> -->
            <span class="du-back" v-if="!infoFlag&&statusTab==0" @click.stop="backList">返回通知列表</span>
        </div>
        <template v-if="statusTab==0">
            <template v-if="infoFlag">
                <div v-for="(item) in noticeList" :key="item.id" class="notice-one">
                    <div class="notice-title">
                        <div :class="!item.read?'font-main':'font-assist'">
                            <span class="notice-new" v-if="item.isnew&&!item.read">新</span>
                            {{ item.title }}
                        </div>
                    </div>
                    <span class="notice-times">
                  {{ item.created_at }}
                  </span>
                    <a class="notice-info" href="javascript:void(0)" @click.stop="goInfo(item)">查看详情</a>
                </div>
                <Pagetion :total="total" @getpageValue="getpageValue" class="pos-page"/>
            </template>
            <template v-else>
                <div class="info-title">{{ currentItem.title }}</div>
                <div class="info-times">发布于：{{ currentItem.created_at }}</div>
                <div class="info-content">
                    <div v-html="currentItem.content"></div>
                </div>
                <div class="go-info-page">
                    <div @click.stop="goInfo(lastItem)" v-if="lastItem!=null">
                        <img src="../assets/pre-page.png" alt="">
                        <span class="f-blue ml10">上一篇</span>
                        <span class="f-blue f-size ml10">{{ lastItem.title }}</span>
                    </div>
                    <div v-else>
                        <img src="../assets/pre-page.png" alt="">
                        <span style="color:gray;" class="f-blue ml10">上一篇</span>
                        <span style="color:gray;width:36px;" class="f-blue f-size ml10">暂无</span></div>
                    <div @click.stop="goInfo(nextItem)" v-if="nextItem!=null">
                        <span class="f-blue f-size">{{ nextItem.title }}</span>
                        <span class="f-blue ml10">下一篇</span>
                        <img src="../assets/next-page.png" alt="" class="ml10">
                    </div>
                    <div v-else>
                        <span style="color:gray;width:36px;" class=" f-size">暂无</span>
                        <span style="color:gray;" class="f-hui ml10">下一篇</span>
                        <img src="../assets/next-page.png" alt="" class="ml10">
                    </div>
                </div>
            </template>
        </template>
        <template v-else>
            <div class="yao-wrap">
                <div class="yao-line">
                    <div class="yao-content">
                        <h1 class="yao-title">{{ noticeItem.title }}</h1>
                        <div class="yao-hen-line"></div>
                        <div class="yao-art">
                            <p>{{ noticeItem.intro }}</p>
                            <div class="yao-end">参会名单回执截止时间：{{ noticeItem.start_time.split(' ')[0] }} -
                                {{ noticeItem.end_time.split(' ')[0] }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="yao-bg"></div>
            </div>
            <div class="ty-hui-title" style="margin-top: 30px">参会单位信息</div>
            <div class="ty-hui-img mb20">
                <img src="../assets/hui-line.png" alt="">
            </div>
            <table class="hui-info">
                <tr>
                    <th>单位名称</th>
                    <td colspan="3">
                        <div class="put-wrap">
                            <input v-model="noticeDw.name" type="text" placeholder="请输入单位名称">
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>是否住宿</th>
                    <td>
                        <el-radio v-model="noticeDw.isstay" label="1" class="huiradio">单间</el-radio>
                        <el-radio v-model="noticeDw.isstay" label="2" class="huiradio">标间</el-radio>
                        <el-radio v-model="noticeDw.isstay" label="0" class="huiradio">不住宿</el-radio>
                    </td>
                    <th>是否参展</th>
                    <td>
                        <el-radio v-model="noticeDw.isexhibition" label="1" class="huiradio">是</el-radio>
                        <el-radio v-model="noticeDw.isexhibition" label="0" class="huiradio">否</el-radio>
                    </td>
                </tr>
                <tr>
                    <th>发票收件地址</th>
                    <td>
                        <div class="put-wrap">
                            <input v-model="noticeDw.address" type="text" placeholder="请输入发票收件地址">
                        </div>
                    </td>
                    <th>联系人姓名及电话</th>
                    <td>
                        <div class="put-wrap">
                            <input v-model="noticeDw.contact_number" type="text" placeholder="请输入单位电话">
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>开票信息</th>
                    <td colspan="3">
                        <div class="put-wrap" style="margin:10px">
                            <el-input :rows="4" v-model="noticeDw.pay_taxes" type="textarea" placeholder="请输入开票信息"></el-input>
                        </div>
                    </td>
                </tr>
            </table>
            <div class="ty-hui-title" style="margin-top: 30px">参会人名单</div>
            <div class="ty-hui-img mb20">
                <img src="../assets/hui-line.png" alt="">
            </div>
            <table class="hui-table-list">
                <tr>
                    <th></th>
                    <th>参展人员姓名</th>
                    <th>性别</th>
                    <th>职务</th>
                    <th>联系电话</th>
                    <th>邮箱</th>
                    <th>操作</th>
                </tr>
                <tr v-for="(item,index) in noticeUserList " :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.sex }}</td>
                    <td>{{ item.post }}</td>
                    <td>{{ item.contact_number }}</td>
                    <td>{{ item.email }}</td>
                    <td>
                        <img @click="toEdit(item,index)" src="../assets/hui-edit.png" alt="" class="hui-edit">
                        <img @click="toDelete(index)" src="../assets/hui-delete.png" alt="" class="hui-delete ml10">
                    </td>
                </tr>
            </table>
            <div class="yao-add" @click="openAddPerson">
                <img src="../assets/yaoadd.png" alt="">
                <span>添加参会人员</span>
            </div>
            <div class="yellow-line"></div>
            <div @click="onSubmitTap()" class="subSq-btn">
                <img src="../assets/19178@2x.png" alt="">
                <span>提交申请</span>
            </div>

        </template>
        <el-dialog :visible.sync="dialogVisible" class="hui" width="436px">
            <div >
                <el-form ref="form" style="margin-right: 60px" :model="noticeUser" label-width="80px">
                    <el-form-item label="姓名">
                        <el-input v-model="noticeUser.name"></el-input>
                    </el-form-item>
                    <el-form-item label="性别">
                        <el-radio-group v-model="noticeUser.sex">
                            <el-radio label="男">男</el-radio>
                            <el-radio label="女">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="职务">
                        <el-input v-model="noticeUser.post"></el-input>
                    </el-form-item>
                    <el-form-item label="电话">
                        <el-input v-model="noticeUser.contact_number"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱">
                        <el-input v-model="noticeUser.email"></el-input>
                    </el-form-item>
                </el-form>
                <div class="">
                    <el-button style="background: #3D63DF;color:white;" type="info" plain class="sure-btn" @click.stop="subPerson">确认添加</el-button>
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
import AllHeader from "@/components/Modal/AllHeader";
import Pagetion from "@/components/Modal/Pagetion";
import Lineconbgtir from "@/components/Modal/Line";
import Downinpu from "@/components/Modal/Downinpu";
import {
    Message, //申报列表
    YearNotice,
    StoreYearNotice, UpdaeYearNotice,
    PerformanceList, PerformanceNextAndLast, GetMember
} from "../utils/api.js";

export default {
    name: "performance",
    components: {
        // AllHeader,
        Pagetion,
        // Lineconbgtir,
        // Downinpu,
    },
    data() {
        return {
            showErr: false,
            token: "",
            istrr: true,
            lable: "已填报的",
            fileList: [],
            total: 0,
            achievementList: [],
            img: "../assets/apple.png",
            noticeList: [],
            list: [],
            file_urls: [],
            statusTab: 0,//选项卡下标
            dialogVisible: false,//年会弹窗
            zhu: '1',
            join: '1',
            infoFlag: true, //是否进入信息详情
            currentItem: null,
            nextItem: null,
            lastItem: null,
            noticeItem: null,
            noticeDw: {isstay: '1', isexhibition: '0'},
            noticeUserList: [],
            noticeUser: {
                name: '',
                sex: '男',
                post: '',
                contact_number: '',
                email: '',
            },
            editIndex: -1,
            member: null
        };
    },
    mounted() {
        this.token = "Bearer " + localStorage.getItem("TOKEN");
        this.initList(1);
        YearNotice().then(res => {
            console.log(res);
            this.noticeItem = res[0];
            if (res[1]) {
                this.noticeDw = res[1];
            }
            if (res[2]) {
                this.noticeUserList = res[2];
            }
            console.log(this.noticeDw)
        });

        GetMember().then(res => {
            this.member = res;
            this.noticeDw.name = this.member.name;
            this.noticeDw.contact_number = this.member.contact_number;
            console.log(this.member, 'this.member')
        });
    },
    methods: {
        //返回到列表
        backList() {
            this.infoFlag = true
        },
        //展示详情
        goInfo(item) {
            this.currentItem = item;
            console.log(this.currentItem, 'goInfoitem');
            this.infoFlag = false;
            PerformanceNextAndLast(this.currentItem.id).then((res) => {
                console.log(res)
                this.lastItem = res[0];
                this.nextItem = res[1];
            });
        },
        //提交参会人员信息
        subPerson() {
            if (!this.noticeUser.name) {
                this.$message({message: "请输入姓名", type: "warning",});
                return;
            }
            if (!this.noticeUser.contact_number) {
                this.$message({message: "请输入电话", type: "warning",});
                return;
            }
            if (this.editIndex != -1) {
                this.noticeUserList[this.editIndex] = {
                    name: this.noticeUser.name,
                    sex: this.noticeUser.sex,
                    post: this.noticeUser.post,
                    contact_number: this.noticeUser.contact_number,
                    email: this.noticeUser.email,
                    notice_id: this.noticeItem.id
                }
            } else {
                this.noticeUserList.push({
                    name: this.noticeUser.name,
                    sex: this.noticeUser.sex,
                    post: this.noticeUser.post,
                    contact_number: this.noticeUser.contact_number,
                    email: this.noticeUser.email,
                    notice_id: this.noticeItem.id
                })
            }
            this.editIndex = -1;
            this.dialogVisible = false;
        },
        //添加参会人员信息
        openAddPerson() {
            this.noticeUser = {
                name: '',
                sex: '男',
                post: '',
                contact_number: '',
                email: '',
            };
            this.dialogVisible = true;
        },
        toEdit(item, index) {
            this.editIndex = index;
            this.noticeUser = {
                name: item.name,
                sex: item.sex,
                post: item.post,
                contact_number: item.contact_number,
                email: item.email,
            };
            this.dialogVisible = true;
        },
        toDelete(index) {
            this.noticeUserList.splice(index, 1);
        },
        //  tab切换
        setTab(index) {
            this.statusTab = index
        },
        initList(page) {
            const data = {
                page_size: 10,
                page: page,
            };
            PerformanceList(data).then((res) => {
                console.log("res", res);
                res.data.forEach(element => {
                    let curDate = new Date();
                    curDate.setDate(curDate.getDate() - 2);
                    let beginDate = new Date(element.created_at.replace(/-/g, "/"));
                    console.log(curDate, "curDate")
                    console.log(beginDate, "beginDate")
                    if (curDate < beginDate) {
                        element.isnew = true;
                    } else {
                        element.isnew = false;
                    }
                });
                this.noticeList = res.data;
                this.total = res.total;
            });
        },
        getpageValue(index) {
            this.initList(index);
        },
        // 提交审核
        onSubmitTap() {
            //判断当前时间是否大于年会时间或者小于年会时间
            let now = new Date();
            let start = new Date(this.noticeItem.start_time.replace(/-/g,'/'));
            let end = new Date(this.noticeItem.end_time.replace(/-/g,'/'));
            end.setDate(end.getDate()+1);
            console.log(end,'end');
            if(now<start){
                this.$message({message: "回执时间未开始,不允许填写回执表。", type: "error",});
                return;
            }
            if(now>end){
                this.$message({message: "回执时间已截止或者过期了的，不允许填写回执表。", type: "error",});
                return;
            }

            if (!this.noticeDw.name) {
                this.$message({message: "请输入单位名称", type: "error",});
                return;
            }
            if (!this.noticeDw.contact_number) {
                this.$message({message: "请输入单位电话", type: "error",});
                return;
            }
            if (this.noticeUserList.length == 0) {
                this.$message({message: "请输入参会人员", type: "error",});
                return;
            }
            this.noticeDw.notice_id = this.noticeItem.id;
            if (this.noticeDw.id) {
                UpdaeYearNotice(this.noticeDw.id, {
                    noticeDw: this.noticeDw,
                    noticeUserList: this.noticeUserList
                }).then(res => {
                    console.log(res);
                    this.$message({
                        message: "提交成功",
                        type: "success",
                    });
                }).catch((err) => {
                    this.$message.error(err);
                });
            } else {
                StoreYearNotice({
                    noticeDw: this.noticeDw,
                    noticeUserList: this.noticeUserList
                }).then((res) => {
                    console.log(res);
                    this.$message({
                        message: "提交成功",
                        type: "success",
                    });
                })
                    .catch((err) => {
                        this.$message.error(err);
                    });
            }
        },
    },
};
</script>

<style scoped lang="less">
.upload {
    margin-top: 40px;
}

.upload-demo {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}

.uploadheader {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;

    span {
        margin-right: 10px;
        color: #71767c;
    }
}

.block-submit {
    margin-top: 36px;
    margin-bottom: 44px;
}

.achievement {
    display: flex;
    flex-wrap: wrap;

    .achievementList {
        width: 422px;
        height: 158px;
        background: #FFFFFF;
        border: 1px dashed #C8CDD5;
        opacity: 1;
        box-sizing: border-box;
        margin-bottom: 20px;
        padding: 20px 24px;
        box-sizing: border-box;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;

        &:nth-child(2n) {
            margin-left: 14px;
        }

        .right {
            width: 91px;
            height: 32px;
            background: #FFFFFF;
            opacity: 1;
            border-radius: 6px;
            line-height: 32px;
            cursor: pointer;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
        }

        .gray {
            border: 1px solid #D4DBDD;
            color: #C8CDD5;
        }

        .blue {
            border: 1px solid #194ABE;
            color: #194ABE;
        }

        .left {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-evenly;

            p {
                &:nth-child(1) {
                    font-size: 20px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    line-height: 29px;
                    color: #0C0D0F;
                }

                &:nth-child(2) {
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    line-height: 26px;
                    color: #194ABE;
                }

                &:nth-child(3), &:nth-child(4) {
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    line-height: 26px;
                    color: #7C828A;
                }
            }
        }
    }
}

.notice-tab {
    margin-top: 15px;
    height: 54px;
    border-bottom: 1px solid rgba(0, 0, 0, .15);
    text-align: left;

    div {
        margin-right: 10px;
        cursor: pointer;
        display: inline-block;
        width: 88px;
        height: 54px;
        line-height: 54px;
        font-size: 22px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #7C828A;
        position: relative;

        span {
            display: none;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 4px;
            background: linear-gradient(90deg, #6284F1 0%, #6889F3 30%, #FF8640 100%);
        }

        &.focus {
            width: 88px;

            font-size: 22px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #12151C;

            span {
                display: block;
            }
        }
    }

    .du {
        float: right;
        display: flex;
        width: 124px;
        height: 36px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #3D63DF;
        font-size: 16px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #3D63DF;
        align-items: center;
        justify-content: center;
        margin-top: 5px;
        cursor: pointer;

        img {
            margin-right: 10px;
            width: 19px;
            height: auto;
        }
    }

    .du-back {
        display: inline-block;
        margin-top: 5px;
        float: right;
        width: 128px;
        height: 31px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #9FA6AF;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #9FA6AF;
        text-align: center;
        line-height: 31px;
        cursor: pointer;
    }
}

.notice-one {
    border-bottom: 1px dotted #C8CDD5;
    padding: 20px 0;
    display: flex;
    align-items: center;

    .notice-title {
        flex: 1;
        height: 54px;
        position: relative;

        > div {
            position: absolute;
            width: 100%;
            left: 0;
            top: 0;
            height: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
            align-items: center;
            line-height: 54px;
        }
    }

    .notice-times {
        width: 126px;
        font-size: 16px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #9FA5AE;
    }

    .notice-info {
        font-size: 16px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #3D63DF;
        width: 102px;
        height: 36px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        text-align: center;
        line-height: 36px;
        border: 1px solid #3D63DF;
    }
}

.notice-new {
    width: 31px;
    height: 23px;
    background: #FF8640;
    border-radius: 14px 14px 14px 14px;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: inline-block;
    margin-right: 6px;
    text-align: center;
    line-height: 23px;
}

.yao-wrap {
    margin-top: 50px;
    overflow: hidden;
    position: relative;
    margin-bottom: 20px;
}

.yao-line {
    border: 4px solid #EBEEF5;
    padding: 5px;
}

.yao-content {
    background: #F5F8FB;
    border: 1px dashed #EBEEF5;
    padding-top: 85px;
}

.yao-bg {
    background: url("../assets/yao_bg.png");
    height: 58px;
    background-size: 100% 100%;
    position: absolute;
    left: 0;
    width: 100%;
    top: 0;
}

.yao-title {
    font-size: 28px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #181E23;
    line-height: 40px;
    margin-bottom: 5px;
}

.yao-hen-line {
    width: 202px;
    height: 4px;
    background: linear-gradient(90deg, #3D63DF 0%, #3D63DF 13%, #FF8640 91%, rgba(255, 134, 64, 1) 100%);
    margin-right: auto;
    margin-left: auto;
}

.yao-art {
    text-align: left;
    padding: 30px;

    p {
        text-indent: 2em;
        line-height: 2;
        font-size: 16px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #12151C;
    }
}

.yao-add {
    display: flex;
    justify-content: center;
    height: 50px;
    background: #F5F8FB;
    align-items: center;
    border: 1px solid #EBEEF5;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(61, 99, 223, 1);

    img {
        width: 17px;
        margin-right: 15px;
    }
}

.yao-end {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #3D63DF;
    text-align: right;
}

.hui /deep/ .el-form-item__label {
    min-width: auto !important;
}

.hui /deep/ .el-dialog__headerbtn {
    right: 0;
    top: 0;
    transform: translate(40%, -40%);
    border-radius: 100%;
    background: #fff;
    font-size: 18px;
    padding: 5px 6px;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
}

/deep/ .sure-btn.el-button {
    width: 189px;
    height: 50px;
}

.ty-hui-title {
    font-size: 20px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #12151C;
}

.ty-hui-img {
    img {
        width: 96px;
    }
}

.hui-info {
    width: 100%;
    border-collapse: collapse;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;

    tr:nth-child(odd) {
        background: #F5F8FB;

        th {
            background: #EAF0F6;
        }
    }

    tr:nth-child(even) {
        background: #FBFDFF;

        th {
            background: #F5F8FB;
        }
    }

    th {
        width: 129px;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: bold;
        color: #323232;
        padding: 20px 0;
        border-top: 1px solid #EBEEF5;
        border-left: 1px solid #EBEEF5;
    }

    td {
        border-top: 1px solid #EBEEF5;
        border-left: 1px solid #EBEEF5;

    }
}

.put-wrap {
    margin-right: 20px;
    margin-left: 20px;

    input {
        width: 100%;
        box-sizing: border-box;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #D9DDE2;
        height: 36px;
        outline: none;
        padding-left: 10px;
    }
}

.huiradio /deep/ .el-radio__inner {
    width: 20px;
    height: 20px;
    background: transparent;
    background-color: transparent;
    border-color: transparent;
    border: none;
    background: url("../assets/ry.png");
    background-size: 100% 100%;
}

.huiradio /deep/ .el-radio__input.is-checked .el-radio__inner {
    background: transparent;
    background-color: transparent;
    border-color: transparent;
    background: url("../assets/rn.png");
    background-size: 100% 100%;
}

.huiradio /deep/ .el-radio__inner::after {
    background: transparent;
}

.hui-edit {
    width: 20px;
}

.hui-delete {
    width: 20px;
}

.mr20 {
    margin-right: 20px;
}

.hui-table-list {
    border-collapse: collapse;
    width: 100%;
    border-bottom: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;

    tr:nth-child(odd) {
        background: #F5F9FB;
    }

    tr:nth-child(even) {
        background: #FFFFFF;
    }

    th {
        border-top: 1px solid #EBEEF5;
        border-left: 1px solid #EBEEF5;
        padding: 15px 0;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: bold;
        color: #9FA6AF;
    }

    td {
        border-top: 1px solid #EBEEF5;
        border-left: 1px solid #EBEEF5;

        padding: 15px 0;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }
}

.mb20 {
    margin-bottom: 20px;
}

.subSq-btn {
    width: 189px;
    height: 50px;
    background: #275ad9;
    border-radius: 4px 4px 4px 4px;
    margin-right: auto;
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;

    img {
        width: 18px;
        margin-right: 10px;
    }
}

.yellow-line {
    background: #FF8640;
    height: 4px;
    margin-bottom: 30px;
    margin-top: 30px;
}

.info-title {
    font-size: 28px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #181E23;
    border-bottom: 1px dotted #C8CDD5;
    padding-bottom: 20px;
    margin-top: 30px;
}

.info-times {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #7C828A;
    margin-top: 20px;
    margin-bottom: 20px;
}

.info-content {
    margin-left: 50px;
    margin-right: 50px;
    text-align: left;

    img {
        display: block;
        width: 100%;
        margin-bottom: 20px;
    }

    p {
        font-size: 16px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #181E23;
        line-height: 1.8;
    }
}

.go-info-page {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #D4DBDD;
    margin-top: 50px;
    padding-top: 30px;
    color: rgba(86, 86, 86, 1);

    > div {
        display: flex;
        align-items: center;
        font-size: 14px;

        img {
            width: 20px;
        }
    }
}

.f-blue {
    color: rgba(25, 74, 190, 1);
}

.f-hui {
    color: rgba(158, 165, 175, 1);
}

.f-size {
    display: inline-block;
    width: 160px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.ml10 {
    margin-left: 10px;
}

.box_bg {
    box-shadow: 0px 12px 18px 1px #DCE2F8;
}

.font-assist {
    color: #7C828A;
}

.font-main {
    color: #0C0D0F;
}
</style>
